import React from 'react'

function Footer() {
  return (
        <section className="BottomIndexContainer" id='BottomIndexContainer'>
            <div className="TopBottomIndexSection BottomIndexSection">
                <div className="MainBackgroundAnimateContainer" id='FooterMainImageContainer' style={{height: "100%"}}>
                    <img src="/Assets/images/AnimateBG/FooterNew.jpg" className="MainBackgroundAnimate" id='FooterMainBackgroundImage' style={{opacity:0}}/>
                    <div className="loading_grey" style={{width: '100%', height: '100%', position: 'absolute', top: 0, left: 0}} id="LoadingBottomBackground"/>
                    <div style={{backgroundColor: "rgba(0, 0, 0, 0.4)", width: "100%", height: "100%", position: "absolute", top: "0", left: "0"}}></div>
                </div>
                <p className="BottomTextQuotes InterRegularTextFont" id="FooterBannerText">Menginap <span className="InterBoldTextFont">Nyaman</span>, <span className="InterBoldTextFont">Pengalaman</span> Tak Terlupakan</p>
            </div>
            <div className="BottomMenuSection InterMediumTextFont">
                <div className="BottomMenuSectionWrapper">
                    <img src="/Assets/images/Icon/pingingo-icon.svg" className="PinginGoLogo"/>
                    <div className="BottomMenuTextMainWrapper">
                        <div className="Bottom1stWrapper">
                            <p className="BottomMenuHeaderText PoppinsLightTextFont" id="ForeMostFooterBelowText">More Ping and Share, Endless Experience</p>
                            <div className="BottomIconAndTextWrapper">
                                <img src="/Assets/images/Icon/WhatsApp.svg" alt="" />
                                <div className="BottomTwoTextWrapper">
                                    <p className="BottomMenuText PoppinsLightTextFont" id="FooterWhatsAppHeaderText">WhatsApp</p>
                                    <a href="https://api.whatsapp.com/send?phone=628175750000" target="_blank">
                                        <p className="BottomMenuText HyperlinkUnderlineText PoppinsRegularTextFont">+62 817-5750-000</p>
                                    </a>
                                </div>
                            </div>
                            <div className="BottomIconAndTextWrapper">
                                <img src="/Assets/images/Icon/Mail.svg" className="BottomIMGNotWA" />
                                <div className="BottomTwoTextWrapper">
                                    <p className="BottomMenuText PoppinsLightTextFont" id="FooterEmailHeaderText">Email</p>
                                    <a href="mailto:cs@pingingo.com" target="_blank">
                                        <p className="BottomMenuText HyperlinkUnderlineText PoppinsRegularTextFont">cs@pingingo.com</p>
                                    </a>
                                </div>
                            </div>
                            <div className="BottomIconAndTextWrapper">
                                <img src="/Assets/images/Icon/Location.svg" className="BottomIMGNotWA" />
                                <div className="BottomTwoTextWrapper">
                                    <p className="BottomMenuText PoppinsLightTextFont" id="FooterAlamatHeaderText">Alamat</p>
                                    <p className="BottomMenuText PoppinsRegularTextFont" style={{color: "#667085"}}>Foresta Business Loft 2, Unit 29, Jl. BSD Raya Utama No.21, Pagedangan, Tangerang Regency, Banten 15339</p>
                                </div>
                            </div>
                        </div>
                        <div className="Bottom2ndWrapper">
                            <p className="BottomMenuHeaderText PoppinsExBoldTextFont" id="CompanyHeaderTextFooter">Company</p>
                            <a id="FooterTentangKamiHREF">
                                <p className="BottomMenuText HyperlinkUnderlineText PoppinsRegularTextFont BottomLightColor" id="FooterTentangKamiText">Tentang Kami</p>
                            </a>
                            <a id='FooterContactUsHREF'>
                                <p className="BottomMenuText HyperlinkUnderlineText PoppinsRegularTextFont BottomLightColor" id="FooterContactUsText">Hubungi PinginGo</p>
                            </a>
                            <a id="FooterTermsandConditionHREF">
                                <p className="BottomMenuText HyperlinkUnderlineText PoppinsRegularTextFont BottomLightColor" id="FooterTermsandConditionText">Syarat dan Ketentuan</p>
                            </a>
                            <a id="FooterPrivacyHREF">
                                <p className="BottomMenuText HyperlinkUnderlineText PoppinsRegularTextFont BottomLightColor" id="FooterPrivacyText">Kebijakan Privasi</p>
                            </a>
                            <a id="FooterFAQHREF">
                                <p className="BottomMenuText HyperlinkUnderlineText PoppinsRegularTextFont BottomLightColor" id="FooterFAQText">Pusat Bantuan</p>
                            </a>
                        </div>

                        <div className="Bottom2ndWrapper">
                            <p className="BottomMenuHeaderText PoppinsExBoldTextFont" id="InfoHeaderTextFooter">Info</p>
                            <a href="https://blog.pingingo.com/tips-trick/registrasi-tanpa-ribet-pakai-referral/">
                                <p className="BottomMenuText HyperlinkUnderlineText PoppinsRegularTextFont BottomLightColor" id="FooterHowToBookText">Cara booking PinginGo</p>
                            </a>
                            <a className='ListingMitraButtons'>
                                <p className="BottomMenuText HyperlinkUnderlineText PoppinsRegularTextFont BottomLightColor" id="FooterDaftarkanAkAndaText">Daftarkan Akomodasi Anda</p>
                            </a>
                            <a href="https://blog.pingingo.com/" >
                                <p className="BottomMenuText HyperlinkUnderlineText PoppinsRegularTextFont BottomLightColor" id="FooterBlogPingingoText">Blog PinginGo</p>
                            </a>
                        </div>

                        <div className="Bottom2ndWrapper">
                            <p className="BottomMenuHeaderText PoppinsExBoldTextFont" id="FollowUsTextFooter">Ikuti Kami</p>
                            <div className="BottomIconAndTextWrapper">
                                <img src="/Assets/images/ButtonIcon/Social/ig-instagram-icon.svg" className="BottomIMGNotWA" />
                                <div className="BottomTwoTextWrapper">
                                    <p className="BottomMenuText PoppinsLightTextFont" id="FooterInstagramText">Instagram</p>
                                    <a href="https://www.instagram.com/pingingo.official/" target="_blank">
                                        <p className="BottomMenuText HyperlinkUnderlineText PoppinsRegularTextFont">pingingo.official</p>
                                    </a>
                                </div>
                            </div>
                            <div className="BottomIconAndTextWrapper">
                                <img src="/Assets/images/ButtonIcon/Social/tiktok-square-color-icon.svg" className="BottomIMGNotWA" />
                                <div className="BottomTwoTextWrapper">
                                    <p className="BottomMenuText PoppinsLightTextFont" id="FooterTikTokText">TikTok</p>
                                    <a href="https://www.tiktok.com/@pingingo.official" target="_blank">
                                        <p className="BottomMenuText HyperlinkUnderlineText PoppinsRegularTextFont">pingingo.official</p>
                                    </a>
                                </div>
                            </div>
                            <div className="BottomIconAndTextWrapper">
                                <img src="/Assets/images/ButtonIcon/Social/facebook-square.svg" className="BottomIMGNotWA" />
                                <div className="BottomTwoTextWrapper">
                                    <p className="BottomMenuText PoppinsLightTextFont" id="FooterFacebookText">Facebook</p>
                                    <a href="https://www.facebook.com/profile.php?id=61562294233475" target="_blank">
                                        <p className="BottomMenuText HyperlinkUnderlineText PoppinsRegularTextFont">PinginGo</p>
                                    </a>
                                </div>
                            </div>
                            <div className="BottomIconAndTextWrapper">
                                <img src="/Assets/images/ButtonIcon/Social/x-square-background.svg" className="BottomIMGNotWA" />
                                <div className="BottomTwoTextWrapper">
                                    <p className="BottomMenuText PoppinsLightTextFont">X</p>
                                    <a href="https://x.com/Pingin_Go" target="_blank">
                                        <p className="BottomMenuText HyperlinkUnderlineText PoppinsRegularTextFont">Pingin_Go</p>
                                    </a>
                                </div>
                            </div>
                        </div>


                    </div>

                </div>
            </div>
            <div className="BottomEndSection">
                <div className="BottomMenuSectionWrapper" style={{display: "flex"}}>
                    <p className="CopyrightEndText PoppinsRegularTextFont FooterCopyrightText">2023 - 2025 PinginGo©  All rights reserved</p>
                </div>
            </div>
        </section>
  )
}

export default Footer